import styled from "styled-components";
export const HeaderBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 50px; /* або потрібна висота */

  display: flex;
  align-items: center; /* вертикальне центрування */
  background-color: #ddddddff;
  padding-left: 100px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  z-index: 1000;
`;
